export const vipStudents = [
  {
    id: 1,
    name: "Syed Shah Ali",
    role: "Ethical hacker",
    image: "/images/students/ali.jpeg"
  },
  {
    id: 2,
    name: "Muhammad Zaid",
    role: "Full stack developer",
    image: "/images/students/zaid.jpeg"
  },
  {
    id: 3,
    name: "Laiba Saleem",
    role: "Python Developer",
    image: "/images/students/laiba.png"
  },
  {
    id: 4,
    name: "Syed Ayan Hussain",
    role: "Web developer",
    image: "/images/students/ayan.jpeg"
  }
];
